module.exports = __webpack_public_path__ + "img/asura_m.bf519682.png";